import ScrollToSmooth from 'scrolltosmooth/dist/scrolltosmooth.min';

export default class SmoothScroll {
  // html selector for the component
  static selectorString() {
    return '.js-smooth-scroll';
  }

  // rootNode = html element with js-class
  // props = data attribute 'props' to pass down customization
  constructor(rootNode) {
    const scroller = new ScrollToSmooth(rootNode);
    const id = rootNode.getAttribute('href');

    scroller.init();
    scroller.update({
      duration: 1500,
      easing: 'easeOutCubic',
    });

    rootNode.addEventListener('click', () => scroller.scrollTo(id));
  }
}
